/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],
  rebateProgramName: '',
  manufacturerList: [],
  isLoading: false,
  manufacturerSelectedId: '',
  manufacturerSelectedName: '',
  isAllManufacturersSelected: true,
  scrollDownManufacturers: true,
  searchResult: [],
  quarterValue: '',
  selectedRowIndexValue: '',
  zeroUraMaxQuarter: '',
  searchScreenVar: {
    rebateProgramValue: '',
    selectedPlanType: '',
    quarterValue: '',
    isAllManufacturersSelected: true,
    scrollDownManufacturers: true,
    rebateProgrameName: '',
  },
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_ZERO_URA:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_ZERO_URA:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_ZERO_URA:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.GET_MAX_QUARTER_ZERO_URA:
      return {
        ...state,
        zeroUraMaxQuarter: action.zeroUraMaxQuarter,
      };
    // Manufacturer Grid
    case ActionTypes.GET_MANUFACTURER_LIST_ZERO_URA:
      return { ...state, manufacturerList: action.manufacturerList };
    // For Search Screen result
    case ActionTypes.GET_ZERO_URA:
      return { ...state, searchResult: action.searchResult };
    case ActionTypes.REFRESH_ZERO_URA:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    default:
      return state;
  }
};

export default reducer;
